import type { SafetyAlertChannelKey } from '../utils/safetyAlertLogDisplay';

export type SafetyAlertChannelOverrides = Record<SafetyAlertChannelKey, boolean>;

export const SAFETY_ALERT_CHANNEL_LABELS: Record<SafetyAlertChannelKey, string> = {
  sms: '문자(SMS)',
  kakao: '카카오 알림톡',
  wearable: '웨어러블',
};

export function overridesFromPool(pool?: {
  safety_alert_channel_overrides?: Partial<SafetyAlertChannelOverrides> | null;
} | null): SafetyAlertChannelOverrides | null {
  const raw = pool?.safety_alert_channel_overrides;
  if (!raw || typeof raw !== 'object') return null;
  return {
    sms: Boolean(raw.sms),
    kakao: Boolean(raw.kakao),
    wearable: Boolean(raw.wearable),
  };
}
